import { render, staticRenderFns } from "./ProductUpdate.vue?vue&type=template&id=27066c51&scoped=true"
import script from "./ProductUpdate.vue?vue&type=script&lang=ts"
export * from "./ProductUpdate.vue?vue&type=script&lang=ts"
import style0 from "./ProductUpdate.vue?vue&type=style&index=0&id=27066c51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27066c51",
  null
  
)

export default component.exports